import { useVisibleFreefieldCategoriesWithValues } from "shared/utils/freeFields/hooks";
import ReadonlyFreefieldValue from "components/Freefields/Readonly/ReadonlyFreefieldValue";
import { InPageEditableSectionField } from "components/MainSectionTemplate/types";
import React from "react";

export const sidePanelFreeFieldSections = (
  categories: server.dto.FreeFieldCategorySmall[],
  freefieldValues: server.dto.FreeFieldValue[],
): InPageEditableSectionField[] => {
  const freeFieldCategoriesWithValues = useVisibleFreefieldCategoriesWithValues(categories, freefieldValues);
  const freeFieldCategoriesThatHaveVisibleValues = freeFieldCategoriesWithValues.filter(category => category.definitionWithValues.some(ffValue => ffValue.displayValue.hasVisibleValue));

  return freeFieldCategoriesThatHaveVisibleValues.map((category) => [{
    key: `free-field-category-${category.freeFieldCategoryId}`,
    label: "",
    hideLabel: true,
    render: () => <strong>{category.title}</strong>
  },
  ...category.definitionWithValues
    .filter(ffValue => ffValue.displayValue.hasVisibleValue)
    .map((ffValue) => ({
      key: `free-field-definition-${ffValue.freeFieldDefinitionId}`,
      label: ffValue.title,
      sublabel: ffValue.description,
      render: () => <ReadonlyFreefieldValue type={ffValue.type} displayValue={ffValue.displayValue} />,
    }))
  ]).flat();
}